export const getParsedLabels = (labels, othersText) => {
  const parsedLabels = labels.map((label) =>
    label.isOthers ? { ...label, name: othersText } : label
  );

  return parsedLabels;
};

export const getBaseUrl = () => `/developments?commercialization=true`;

export const handleClickBar = (locationId) => {
  let url = getBaseUrl();
  const locations = Array.isArray(locationId) ? locationId : [locationId];
  url += `&location=${locations}`;
  window.open(url, '_blank');
};

export const handleTooltip = (context, labels, translateTooltip) => {
  const labelIndex = context.dataIndex;
  const label = labels[labelIndex];

  if (!label.isOthers) {
    return `${label.name}: ${label.count}`;
  }

  if (label.isOthers && label.othersDetail) {
    return translateTooltip(label.count, label.locationsCount);
  }

  return `${label.name}: ${label.count}`;
};
